/**
 * Patient phone-OTP (M10-T02, ADR-0021). Request a code, verify it, get a
 * short-lived `patient` session token. No passwords. The token is held in
 * memory only (never localStorage — CLAUDE.md), so it dies with the tab.
 */
import { apiFetch } from '../lib/api'

export type PatientUser = { id: string; role: string }

export type PatientSession = {
  token: string
  expires_in: number
  user: PatientUser
}

/** POST /api/v1/patient/otp/request — sends a code by SMS. Throws `ApiError`
 * (e.g. `rate_limited`). Never returns the code. */
export async function requestOtp(phone: string): Promise<void> {
  await apiFetch<{ status: string }>('/api/v1/patient/otp/request', {
    method: 'POST',
    body: { phone },
  })
}

/** POST /api/v1/patient/otp/verify — returns a patient session on success.
 * Throws `ApiError` (`invalid_code`, `no_active_code`, `too_many_attempts`,
 * `rate_limited`). */
export async function verifyOtp(
  phone: string,
  code: string,
): Promise<PatientSession> {
  const body = await apiFetch<{ data: PatientSession }>(
    '/api/v1/patient/otp/verify',
    { method: 'POST', body: { phone, code } },
  )
  return body.data
}
